import { gql } from '@apollo/client';

import { LoginReplyFragment } from '../fragments';

export const LoginTFAMutation = gql`
    mutation loginTFA($token: String!, $totpCode: String!) {
        loginTFA(token: $token, totpCode: $totpCode) {
            ...LoginReply
        }
    }
    ${LoginReplyFragment}
`;
